// extracted by mini-css-extract-plugin
export default {"operatorTag":"PaymentTag_operatorTag__9Y-yw","operatorTagError":"PaymentTag_operatorTagError__fY3hP","refundTag":"PaymentTag_refundTag__rkSo2"};